<template>
  <div class="login-frame">
    <div class="login-frame-title">注册</div>
    <Form class="login" ref="loginForm" :model="reg" :rules="{}" :validOnChange="true">
      <FormItem :showLabel="false" required prop="mobile" label="手机号">
        <div class=" h-input-prefix">
          <div class="h-input-prefix-icon">
            <i class="fa fa-user"></i>
          </div>
          <Input v-model.trim="reg.mobile" type="text" placeholder="请输入手机号" class="h-42px"/>
        </div>
      </FormItem>
      <FormItem :showLabel="false" required prop="code" label="验证码" class="my-16px">
        <div class=" h-input-prefix">
          <div class="h-input-prefix-icon h-input-prefix-icon-code"></div>
          <div class="h-input-group" style="width: auto;flex: 1">
            <Input v-model.trim="reg.code" type="text" placeholder="验证码" maxlength="4"/>
            <SmsVerificationCode :mobile="reg.mobile"/>
          </div>
        </div>
      </FormItem>
      <FormItem :showLabel="false" required prop="password" label="密码" class="!pb-25px">
        <div class=" h-input-prefix">
          <div class="h-input-prefix-icon">
            <i class="fa fa-lock"></i>
          </div>
          <Input v-model.trim="reg.password" placeholder="请输入密码" type="password"/>
        </div>
      </FormItem>
      <FormItem :showLabel="false" class="!pb-0px">
        <div class="flex custom-btn" style="width: 100%; align-items: center;">
          <Checkbox v-model="reg.agree" class="ml-8px">我已阅读并同意金掌柜</Checkbox>
          <Button noBorder text-color="primary" @click="openService">用户协议</Button>和
          <Button noBorder text-color="primary" @click="openPrivacy">隐私政策</Button>
        </div>
      </FormItem>
      <FormItem :showLabel="false" class="!pb-0px">
        <Button @click="regSubmit" :loading="loading" color="primary" block>立 即 注 册</Button>
        <div class="text-center my-32px">
          <span class="text-hover" @click="$emit('changeView','LoginForm')">返回登录</span>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import {message} from "heyui.ext";
import SmsVerificationCode from "../../components/SmsVerificationCode"
import common from "@api/common";

export default {
  name: 'Registered',
  components: {SmsVerificationCode},
  data() {
    return {
      reg: {
        mobile: "",
        code: "",
        password: "",
        agree: false
      },
      loading: false
    };
  },
  methods: {
    regSubmit() {
      let validResult = this.$refs.loginForm.valid();
      if (validResult.result) {
        if (!this.reg.agree) {
        message.warn("请先同意用户协议和隐私政策")
          return;
        }
        this.loading = true;
        common.register(this.reg).then(() => {
          window.location.replace('/');
        }).finally(() => {
          this.loading = false
        });
      }
    },
    openService() {
      window.open(`/common/ServiceAgreements.html?${Date.now()}`, '_blank');
    },
    openPrivacy() {
      window.open(`/common/PrivacyPolicy.html?${Date.now()}`, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-btn {
    :deep(.h-btn) {
      font-size: 14px !important;
      padding: 0 5px !important;
    }
  }
</style>
